<template>
  <g>
    <defs>
      <path
        id="document@1x-a"
        d="M9.375,10 L10.25,10 C10.7332492,10 11.125,9.60824916 11.125,9.125 C11.125,8.64175084 10.7332492,8.25 10.25,8.25 L9.375,8.25 C8.89175084,8.25 8.5,8.64175084 8.5,9.125 C8.5,9.60824916 8.89175084,10 9.375,10 Z M9.375,11.75 C8.89175084,11.75 8.5,12.1417508 8.5,12.625 C8.5,13.1082492 8.89175084,13.5 9.375,13.5 L14.625,13.5 C15.1082492,13.5 15.5,13.1082492 15.5,12.625 C15.5,12.1417508 15.1082492,11.75 14.625,11.75 L9.375,11.75 Z M19,9.0725 C18.9908857,8.99211803 18.9732877,8.91292676 18.9475,8.83625 L18.9475,8.7575 C18.9054291,8.66753228 18.8493108,8.58483173 18.78125,8.5125 L18.78125,8.5125 L13.53125,3.2625 L13.53125,3.2625 C13.4589183,3.19443918 13.3762177,3.13832095 13.28625,3.09625 C13.2601311,3.09254016 13.2336189,3.09254016 13.2075,3.09625 C13.1186129,3.04527369 13.0204454,3.01255118 12.91875,3 L7.625,3 C6.17525253,3 5,4.17525253 5,5.625 L5,17.875 C5,19.3247475 6.17525253,20.5 7.625,20.5 L16.375,20.5 C17.8247475,20.5 19,19.3247475 19,17.875 L19,9.125 C19,9.125 19,9.125 19,9.0725 Z M13.75,5.625 L16.375,8.25 L14.7635135,8.25 C14.2037655,8.25 13.75,7.79623454 13.75,7.23648649 L13.75,5.625 Z M17.25,17.875 C17.25,18.3582492 16.8582492,18.75 16.375,18.75 L7.625,18.75 C7.14175084,18.75 6.75,18.3582492 6.75,17.875 L6.75,5.625 C6.75,5.14175084 7.14175084,4.75 7.625,4.75 L12,4.75 L12,7.375 C12,8.82474747 13.1752525,10 14.625,10 L17.25,10 L17.25,17.875 Z M14.625,15.25 L9.375,15.25 C8.89175084,15.25 8.5,15.6417508 8.5,16.125 C8.5,16.6082492 8.89175084,17 9.375,17 L14.625,17 C15.1082492,17 15.5,16.6082492 15.5,16.125 C15.5,15.6417508 15.1082492,15.25 14.625,15.25 Z"
      />
    </defs>
    <g fill="none" fill-rule="evenodd">
      <rect
        width="24"
        height="24"
        fill="#E3E3E3"
        fill-opacity=".01"
        style="mix-blend-mode:color-burn"
      />
      <use :fill="currentColor" :opacity="opacity" fill-rule="nonzero" xlink:href="#document@1x-a" />
    </g>
  </g>
</template>

<script>
  export default {
    props: {
      currentColor: {
        type: String,
        default: 'black'
      },
      opacity: {
        type: String,
        default: '1'
      }
    }  
  }
</script>